import { gql } from "@apollo/client";

export const GET_RACES_PARTIAL_BETTING_INTERESTS = gql`
  query getGraphRacePartialBettingInterest(
    $tvgRaceIds: [Long]
    $wagerProfile: String
  ) {
    races: races(
      tvgRaceIds: $tvgRaceIds
      profile: $wagerProfile
      sorts: [{ byRaceNumber: ASC }]
    ) {
      id
      tvgRaceId
      bettingInterests {
        biNumber
        saddleColor
        numberColor
        currentOdds {
          numerator
          denominator
        }
        morningLineOdds {
          numerator
          denominator
        }
        runners {
          runnerId
          entityRunnerId
          scratched
          horseName
          jockey
          trainer
        }
      }
    }
  }
`;
